import * as Media from "./mediaStyles";
import { FaGithub, FaFacebook, FaLinkedin } from "react-icons/fa"

export default function MediaContainer() {
  return (
    <Media.Container>
        <Media.MediaItem href="https://github.com/DauntlessDev" target="_blank"><FaGithub/></Media.MediaItem>
        <Media.MediaItem href="https://www.linkedin.com/in/braveleuterio/" target="_blank"><FaLinkedin/></Media.MediaItem>
        <Media.MediaItem href="https://www.facebook.com/braveleuterio" target="_blank"><FaFacebook/></Media.MediaItem>
    </Media.Container>
  );
}
